// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { motion } from "framer-motion";
// import SummaryApi from "../common";
// import displayINRCurrency from "../helpers/displayCurrency";
// import addToCart from "../helpers/addToCart";
// import { useDispatch } from "react-redux";
// import ReviewSection from "../components/ReviewSection";

// const ProductDetails = () => {

//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [data, setData] = useState({});
//   const [activeImage, setActiveImage] = useState("");
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);

//   /* FETCH */
//   const fetchProduct = async () => {
//     const res = await fetch(SummaryApi.productDetails.url, {
//       method: "POST",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({ productId: id }),
//     });

//     const result = await res.json();

//     setData(result.data);
//     setActiveImage(result.data?.productImage?.[0]);

//     if (result.data?.variants?.length) {
//       setSelectedVariant(result.data.variants[0]);
//     }
//   };

//   useEffect(() => {
//     fetchProduct();
//   }, [id]);

//   /* VARIANT FIX */
//   const uniqueRAM = [...new Set(data?.variants?.map(v => v.ram))];
//   const uniqueStorage = [...new Set(data?.variants?.map(v => v.storage))];

//   /* CART */
//   const handleAddToCart = () => {
//     addToCart(data._id, selectedVariant, dispatch);
//   };

//   const handleBuyNow = () => {
//     addToCart(data._id, selectedVariant, dispatch);
//     window.location.href = "/checkout";
//   };

//   const discount = data.price && selectedVariant?.price
//     ? Math.round(((data.price - selectedVariant.price) / data.price) * 100)
//     : 0;

//   const specSections = Object.entries(data?.specifications || {});

//   return (
//     <div className="bg-[#f6f7fb] min-h-screen p-4">

//       <div className="container mx-auto">

//         {/* 🔥 TOP */}
//         <div className="grid lg:grid-cols-2 gap-10 bg-white p-6 rounded-2xl shadow">

//           {/* 🖼 IMAGE */}
//           <div>
//             <motion.img
//               key={activeImage}
//               src={activeImage}
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               className="w-full h-[380px] object-contain bg-gray-50 p-4 rounded-xl"
//             />

//             <div className="flex gap-3 mt-4">
//               {data?.productImage?.map((img) => (
//                 <img
//                   key={img}
//                   src={img}
//                   onClick={() => setActiveImage(img)}
//                   className={`w-20 h-20 border rounded cursor-pointer
//                   ${activeImage === img ? "border-blue-600" : ""}`}
//                 />
//               ))}
//             </div>
//           </div>

//           {/* 🧾 DETAILS */}
//           <div>

//             <h1 className="text-2xl font-semibold">
//               {data.productName}
//             </h1>

//             <div className="flex gap-3 items-center mt-3">
//               <h2 className="text-3xl font-bold text-blue-600">
//                 {displayINRCurrency(selectedVariant?.price)}
//               </h2>

//               <span className="line-through text-gray-400">
//                 {displayINRCurrency(data.price)}
//               </span>

//               {discount > 0 && (
//                 <span className="bg-green-100 text-green-600 px-2 py-1 rounded">
//                   {discount}% OFF
//                 </span>
//               )}
//             </div>

//             {/* RAM */}
//             <div className="mt-4">
//               <p className="font-medium">RAM</p>
//               <div className="flex gap-2 mt-2">
//                 {uniqueRAM.map((ram, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.ram === ram)
//                       )
//                     }
//                     className={`px-3 py-1 border rounded
//                     ${selectedVariant?.ram === ram ? "bg-blue-600 text-white" : ""}`}
//                   >
//                     {ram}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* STORAGE */}
//             <div className="mt-4">
//               <p className="font-medium">Storage</p>
//               <div className="flex gap-2 mt-2">
//                 {uniqueStorage.map((storage, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.storage === storage)
//                       )
//                     }
//                     className={`px-3 py-1 border rounded
//                     ${selectedVariant?.storage === storage ? "bg-blue-600 text-white" : ""}`}
//                   >
//                     {storage}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* BUTTONS */}
//             <div className="flex gap-4 mt-6">

//               <button
//                 onClick={handleAddToCart}
//                 className="flex-1 border py-2 rounded"
//               >
//                 Add to Cart
//               </button>

//               <button
//                 onClick={handleBuyNow}
//                 className="flex-1 bg-blue-600 text-white py-2 rounded"
//               >
//                 Buy Now
//               </button>

//             </div>

//           </div>

//         </div>

//         {/* 🔥 SPECIFICATIONS WITH TABS */}

// <div className="bg-white mt-12 p-6 md:p-8 rounded-3xl shadow-lg">

//   {/* HEADER */}
//   <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
//     <h2 className="text-2xl md:text-3xl font-bold">
//       Technical Specifications
//     </h2>

//     <p className="text-sm text-gray-500 mt-2 md:mt-0">
//       Detailed product information
//     </p>
//   </div>

//   {/* 🔥 TABS (PREMIUM STYLE) */}
//   <div className="flex gap-3 overflow-x-auto pb-3 mb-8 no-scrollbar">

//     {specSections.map(([section], index) => (
//       <motion.button
//         key={index}
//         whileTap={{ scale: 0.95 }}
//         onClick={() => setActiveTab(index)}
//         className={`px-5 py-2 rounded-full whitespace-nowrap text-sm font-medium transition-all
//         ${
//           activeTab === index
//             ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-md"
//             : "bg-gray-100 hover:bg-gray-200 text-gray-700"
//         }`}
//       >
//         {section}
//       </motion.button>
//     ))}

//   </div>

//   {/* 🔥 CONTENT */}
//   {specSections.length > 0 && (
//     <motion.div
//       key={activeTab}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//       className="grid sm:grid-cols-2 md:grid-cols-3 gap-6"
//     >

//       {Object.entries(specSections[activeTab][1]).map(([key, val]) => (
//         <div
//           key={key}
//           className="bg-gray-50 hover:bg-white border rounded-xl p-4 transition shadow-sm hover:shadow-md"
//         >

//           <p className="text-gray-500 text-xs uppercase tracking-wide">
//             {key}
//           </p>

//           <p className="font-semibold text-gray-800 mt-1">
//             {val || "-"}
//           </p>

//         </div>
//       ))}

//     </motion.div>
//   )}

// </div>
// <ReviewSection/>
//       </div>

//     </div>
//   );
// };

// export default ProductDetails;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import SummaryApi from "../common";
import displayINRCurrency from "../helpers/displayCurrency";
import addToCart from "../helpers/addToCart";
import { useDispatch } from "react-redux";

const ProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [activeImage, setActiveImage] = useState("");
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [qty, setQty] = useState(1);

  const fetchProduct = async () => {
    const res = await fetch(SummaryApi.productDetails.url, {
      method: "POST",
      credentials:"include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ productId: id }),
    });

    const result = await res.json();
    setData(result.data);
    setActiveImage(result.data?.productImage?.[0]);

    if (result.data?.variants?.length) {
      setSelectedVariant(result.data.variants[0]);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const uniqueRAM = [...new Set(data?.variants?.map(v => v.ram))];
  const uniqueStorage = [...new Set(data?.variants?.map(v => v.storage))];

  const discount =
    data.price && selectedVariant?.price
      ? Math.round(((data.price - selectedVariant.price) / data.price) * 100)
      : 0;

  const handleAddToCart = () => {
    addToCart(data._id, selectedVariant, dispatch, qty);
  };

  const handleBuyNow = () => {
    addToCart(data._id, selectedVariant, dispatch, qty);
    window.location.href = "/checkout";
  };

  return (
    <div className="bg-[#f4f6fb] min-h-screen p-4">
      <div className="max-w-7xl mx-auto">

        <div className="grid lg:grid-cols-2 gap-10 bg-white rounded-3xl p-6 shadow">

          {/* LEFT IMAGE */}
          <div className="flex gap-4">

            {/* thumbnails */}
            <div className="flex flex-col gap-3">
              {data?.productImage?.map((img) => (
                <img
                  key={img}
                  src={img}
                  onClick={() => setActiveImage(img)}
                  className={`w-16 h-16 object-cover rounded cursor-pointer border
                  ${activeImage === img ? "border-red-500" : ""}`}
                />
              ))}
            </div>

            {/* main image */}
            <div className="flex-1">
              <motion.img
                key={activeImage}
                src={activeImage}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="w-full h-[400px] object-contain rounded-xl bg-[#f7f8fb]"
              />
            </div>
          </div>

          {/* RIGHT DETAILS */}
          <div>

            <h1 className="text-2xl font-semibold">
              {data.productName}
            </h1>

            {/* PRICE */}
            <div className="mt-4">
              <h2 className="text-3xl font-bold text-red-600">
                {displayINRCurrency(selectedVariant?.price)}
              </h2>

              <div className="flex gap-3 items-center mt-1">
                <span className="line-through text-gray-400">
                  {displayINRCurrency(data.price)}
                </span>

                <span className="text-red-500 font-medium">
                  ({discount}% OFF)
                </span>
              </div>

              <p className="text-sm text-red-500 mt-2">
                🔥 Low Stock Only 18 left!
              </p>
            </div>

            {/* OFFER BOX */}
            <div className="bg-green-50 border border-green-200 p-4 rounded-xl mt-4">
              <p className="font-semibold text-green-700">
                Limited Time Offer
              </p>
              <p className="text-sm text-green-600">
                Instant ₹500 Off – Use code <b>First500</b>
              </p>
            </div>

            {/* RAM */}
            <div className="mt-6">
              <p className="font-medium">RAM</p>
              <div className="flex gap-3 mt-2">
                {uniqueRAM.map((ram, i) => (
                  <button
                    key={i}
                    onClick={() =>
                      setSelectedVariant(
                        data.variants.find(v => v.ram === ram)
                      )
                    }
                    className={`px-4 py-2 border rounded-lg
                    ${selectedVariant?.ram === ram
                        ? "border-red-500 text-red-500"
                        : "border-gray-300"
                      }`}
                  >
                    {ram}
                  </button>
                ))}
              </div>
            </div>

            {/* STORAGE */}
            <div className="mt-6">
              <p className="font-medium">Storage</p>
              <div className="flex gap-3 mt-2">
                {uniqueStorage.map((storage, i) => (
                  <button
                    key={i}
                    onClick={() =>
                      setSelectedVariant(
                        data.variants.find(v => v.storage === storage)
                      )
                    }
                    className={`px-4 py-2 border rounded-lg
                    ${selectedVariant?.storage === storage
                        ? "border-red-500 text-red-500"
                        : "border-gray-300"
                      }`}
                  >
                    {storage}
                  </button>
                ))}
              </div>
            </div>

            {/* QUANTITY */}
            <div className="flex items-center gap-4 mt-6">
              <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)} className="px-3 py-1 border">-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)} className="px-3 py-1 border">+</button>
            </div>

            {/* BUTTONS */}
            <div className="mt-6 flex gap-4">

              <button
                onClick={handleAddToCart}
                className="flex-1 py-3 rounded-full text-white font-semibold
                bg-gradient-to-r from-red-600 to-red-500 hover:scale-105 transition"
              >
                ADD TO CART
              </button>

              <button
                onClick={handleBuyNow}
                className="flex-1 py-3 rounded-full bg-black text-white font-semibold"
              >
                BUY IT NOW
              </button>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default ProductDetails;

